module.exports = __webpack_public_path__ + "assets/media/day23.17d9e367.mp3";